export const CONSTANTS_MODE = {
  api: window.settings.ADMIN_API_URL
};

export const CONSTANTS_AUTH = {
  DOMAIN_NAME: window.settings.ADMIN_AUTH0_DOMAIN_NAME,
  CLIENT_ID: window.settings.ADMIN_AUTH0_CLIENT_ID,
  REDIRECT_URI: window.settings.ADMIN_AUTH0_REDIRECT_URI,
  HOME_PATH: '/',
  AUDIENCE: 'admin/v1'
};


// WEBPACK FOOTER //
// ./src/utils/constants.js